export function OnboardingShell({ children }) {
  return (
    <div className="font-inter min-h-screen bg-[#f3f4f6] px-4 py-10 sm:px-6 sm:py-12">
      <div className="relative mx-auto max-w-5xl overflow-hidden rounded-2xl border border-[#e5e7eb] bg-white px-6 py-8 shadow-[0px_8px_30px_rgba(15,23,42,0.06)] sm:px-10 sm:py-10">
        <div
          className="pointer-events-none absolute right-0 top-0 h-40 w-40 rounded-full bg-[#fde7d8] blur-3xl"
          aria-hidden
        />
        <div className="relative">{children}</div>
      </div>
    </div>
  );
}
